import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';
import {
  ToolbarService,
  PrintService,
  SelectionService,
  EditorService,
  EditorHistoryService,
  SfdtExportService,
} from '@syncfusion/ej2-angular-documenteditor';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { Template } from 'src/app/shared/models/iTemplate/Template';
import { DocumentEditorService } from 'src/app/shared/services/document-editor.service';
import { DatePipe } from '@angular/common';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { DataService } from 'src/app/shared/services/data.service';
import { EmailInput } from 'src/app/shared/models/iCourrier/email/email-input';
import { UntypedFormBuilder, UntypedFormControl, Validators, UntypedFormArray, AbstractControl, FormGroup } from '@angular/forms';
import * as async from 'async';
import { EmailRecipient } from 'src/app/shared/models/iCourrier/email/email-recipient';
import { ToastrService } from 'ngx-toastr';
import { v4 as uuidv4 } from 'uuid';
import { DocumentSaveModalComponent } from 'src/app/components/modals/document-save-modal/document-save-modal.component';
import { EmailFileSelectModalComponent } from '../email-file-select-modal/email-file-select-modal.component';
import * as _ from 'underscore';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { ParamsService } from 'src/app/shared/services/params.service';
import { DialogService } from 'primeng/dynamicdialog';
import { QrCodeModalComponent } from 'src/app/components/modals/qr-code-modal/qr-code-modal.component';
import { PrintMode } from 'devexpress-richedit';
import { TranslateService } from '@devinforius/i-essentials';
import RELocalization from 'src/assets/translations/dx-rich.fr.json';
import { loadMessages, locale } from 'devextreme/localization';
import { ServicesService } from 'src/app/shared/services/services.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserInfosDto } from 'src/app/shared/interfaces/users';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { ContactDto, DropdownRole, ServiceDto } from 'src/app/shared/interfaces';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { LibraryParagraphDto } from 'src/app/shared/interfaces/documents/library-paragraph-dto.interface';
import { RolesService } from 'src/app/shared/services/roles.service';
import { AssignAttachmentsComponent } from '../../COURRIER-E/assign-circuit-modal/assign-attachments-modal.component';
import { MailsService } from 'src/app/shared/services/mails.service';
import { ProceduresValidationService } from 'src/app/shared/services/procedures-validation.service';
import { RecipientsService } from 'src/app/shared/services/recipients.service';
import { FilesService } from 'src/app/shared/services/files.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DocumentFormatApi } from 'devexpress-richedit/lib/model-api/formats/enum';
import { Mail } from 'src/app/shared/models/mails/mail';
import { MailDestinataire } from 'src/app/shared/models/mails/mail-destinataire';
import { MailFile } from 'src/app/shared/models/mails/mail-file';
import { MailDTO } from 'src/app/shared/interfaces/mails/mail-dto.interface';
import { ServicesPTreeSelect } from 'src/app/shared/models/iCourrier/service';
import { CreateQRCodeParams } from 'src/app/shared/models/iTemplate/create-qr-code';
import { environment } from 'src/environments/environment';
import { IButtonMenuItem } from '@devinforius/i-essentials/lib/models/i-button-menuitem';
import { IRicheditComponent } from '@devinforius/i-dx-editor';
import { manageServicesSetAsTreeSelect, manageServicesToBeMerged } from 'src/app/shared/utils/manage-services-for-tree-select.utils';
import { DocumentInput } from 'src/app/shared/models';
import { DocumentFusionFieldsDTO, DocumentTemplate } from 'src/app/shared/models/iCourrier/document-template';
import { setServiceDescription } from 'src/app/utils/set-service-description.utils';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { toMergeFieldsForEditor } from 'src/app/shared/utils/merge-fields-for-editor.util';

@Component({
  selector: 'app-document-editor',
  templateUrl: './document-editor.component.html',
  styleUrls: ['./document-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToolbarService, PrintService, SelectionService, EditorService, EditorHistoryService, SfdtExportService, DatePipe],
})
export class DocumentEditorComponent implements AfterViewInit, OnInit {

  public readonly mergeFields = toSignal(this.documentsService.getFusionsField().pipe(map(toMergeFieldsForEditor)), { initialValue: {} });









  /*@doc  https://ej2.syncfusion.com/angular/documentation/document-editor/getting-started/?no-cache=1 */
  public selectedTemplatelocation: string;
  public selectedTemplateName: string;
  public selectedTplLangue: string;
  public LIST_IDS: string[] = [];
  public spellCheckLangId: number;
  public hasModel: boolean;
  public flagFileLoaded: boolean = false;

  public timer;
  public transformedExternalDocument: Blob;

  public lang = localStorage.getItem('lang');

  private routeParams: Params;

  @Input() isSaveMode: boolean;
  @Input() set newMailId(mailId: number) {
    this.documentSource = 'Web';
    this.mailId = mailId;
    this.hasModel = true;
    let mailModeFromRoute;
    async.waterfall([
      (cb) => {
        this.getMail().then(() => cb());
      },
      (cb) => {
        this.routeParams = this.route.snapshot.params;
        mailModeFromRoute = this.routeParams.mode;
        if (this.routeParams.mode === 'emailmodel' || this.routeParams.mode === 'emailnomodel') {
          this.initForm();
          this.getMailFiles(true);
          this.getUserInfos();
          if (this.mailMode === 'emailnomodel') {
            this.getSignatureEmail();
          }
          cb(null);
        } else {
          this.getUserInfos();
          cb();
        }
      },
      (cb) => {
        this.getRecipients().then((listOfContactIds) => {
          // ICOUR-4867 in comments
          if (
            listOfContactIds.ids.length > 0 ||
            listOfContactIds.idsiAdmin.length > 0 ||
            (this.recipientsList?.length && this.recipientsList.some((recipient) => recipient.isFreeContact))
          ) {
            this.getContacts(listOfContactIds).then(() => {
              if (this.recipientsList.length > 0) {
                this.emailForm.patchValue({
                  recipients: this.recipientsList,
                });
              }
              this.cd.markForCheck();
              cb();
            });
          } else {
            this.transformDocument(false);
          }
        });
      },
      () => {
        const mainRecipient = this.destinatairesArray.find((recipient) => recipient.principal);
        if (mainRecipient) {
          if (mainRecipient.libre !== null) {
            mainRecipient.name = mainRecipient.libre;
          } else if (mainRecipient.type === 'SERVICE') {
            mainRecipient.name = this.servicesOfRecipients.find((service) => service.id === mainRecipient.contactId)?.description;
          } else if (mainRecipient.contactiAdminId) {
            mainRecipient.name = this.recipientsFromiAdmin.find((contact) => contact.id === mainRecipient.contactiAdminId)?.name;
          } else if (mainRecipient.contactId) {
            mainRecipient.name = this.recipientsFromiCourrier.find((contact) => contact.id === mainRecipient.contactId)?.name;
          }
          if (mailModeFromRoute === 'emailmodel' || mailModeFromRoute === 'mailModel') {
            this.confirmService.confirm({
              message: 'Voulez-vous envoyer le courrier uniquement à ' + mainRecipient.name + ' (oui) ou à plusieurs destinataires (non)?',
              accept: () => {
                this.transformDocument(true);
                this.publipostageOK = false;
              },
              reject: () => {
                this.publipostageOK = true;
                this.transformDocument(false);
              },
            });
          }
        } else {
          this.transformDocument(false);
        }
      },
    ]);
  }
  @Input() mailId: number;
  public publipostageOK: boolean;
  @Input() set selectedTemplate(value: DocumentTemplate) {
    if (value) {
      this.selectedTemplatelocation = value.rtf;
      this.selectedTemplateName = value.description;
      this.documentSource = value.editeurSourceType ? value.editeurSourceType : 'Web';
      this.selectedDocumentTpl = value;
      if (this.documentSource === 'Externe') {
        this.transformDocument(false);
      }
    }
  }

  @Input() mailMode: string; // to see if it's an email or not
  @Input() formInput: FormData;

  @ViewChild('document_editor') public documenteditorcontainer: IRicheditComponent;
  public selectedDocumentTpl: DocumentTemplate;
  private fileName: string = 'document.docx';
  public templates: Template[];
  public types: string[] = ['.docx', '.doc', '.rtf', '.pdf', '.mail', '.printshop', '.odt', '.html', '.printshop-C5'];
  public selectedType: string = this.types[0];
  public exportBtnItems: IButtonMenuItem[];
  public printBtnItems: MenuItem[];
  public languages: MenuItem[];

  public isFullscreen: boolean;
  @Output() public currentFile = new EventEmitter<string>(); // emit to courrierCreate the document created and or mail sended
  // Email
  public userInfos: UserInfosDto; // Access of the connected user
  public connectedUser: ContactDto; // for email adress of the sender
  public fromEmail: string; // email adress of the connected user to send email
  public courrier: Mail;
  public destinatairesArray: MailDestinataire[] = [];
  public isDataLoaded: boolean;
  public mailFiles: MailFile[] = [];
  public selectedMailFiles: MailFile[] = [];
  public emailForm: FormGroup = new FormGroup({
    recipients: new UntypedFormControl(null, [Validators.required, Validators.email]),
    cc: new UntypedFormControl(null),
    bcc: new UntypedFormControl(null),
    subject: new UntypedFormControl(null, Validators.required),
    files: new UntypedFormControl(null),
    staticAttachments: new UntypedFormControl(null),
  });
  public recipientsList: {
    email: string;
    name: string;
    isFreeContact: boolean;
  }[] = [];
  public emailObject: EmailInput;
  public notEmailList: string = '';
  public contactLangue: string;
  public guid: string;
  public baseUrlDocumentEditor: string;
  public showDocExportBtn: boolean;
  public enableSpellCheck: boolean;
  public displayParagraphes: boolean = false;
  public displayFusion: boolean = false;
  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    event.preventDefault();
    event.returnValue = '';
  }
  public showQuestion: boolean = false;
  public questionForm = new FormGroup({
    ProcedureValidationQuestionPosees: new UntypedFormArray([]),
  });
  public roles: DropdownRole[] = [];
  public lancerValidation: boolean = false;
  public qstValidationAnnulee: boolean = false;
  public isFormSubmit: boolean = false;
  public mousePosition: MouseEvent;
  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    this.mousePosition = event;
  }
  public paragraphes: Record<string, LibraryParagraphDto[]>;
  public fusions: DocumentFusionFieldsDTO;
  public searchValue = '';
  public searchValueBibli = '';
  public emailSignatureRTF = '';
  public theSfdt = '';
  public displayQR = false;
  public documentSource = '';
  public currentPage = 1;
  public arrayCanvas: { page: number; canvas: HTMLCanvasElement }[] = [];
  public showPDFModal = false;
  public pdfConverted: string;
  public blob: Blob;
  public newblob: Blob;

  public serviceParent: ServicesPTreeSelect[] = [];
  public servicesFusionned: {
    label: string;
    value: number;
    id: number;
    parentId: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
  }[] = [];
  public selectedOption = null;
  public translationPlaceholderPTree = null;

  private servicesOfRecipients: ServiceDto[] = [];
  private recipientsFromiCourrier = [];
  private recipientsFromiAdmin = [];

  constructor(
    private spinner: NgxSpinnerService,
    private cd: ChangeDetectorRef,
    private confirmService: ConfirmationService,
    private docService: DocumentEditorService,
    public datepipe: DatePipe,
    private dataService: DataService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private router: Router,
    public params: ParamsService,
    public dialog: DialogService,
    private route: ActivatedRoute,
    private translater: TranslateService,
    private servicesService: ServicesService,
    private usersService: UsersService,
    private contactsService: ContactsService,
    private documentsService: DocumentsService,
    private rolesService: RolesService,
    private mailsService: MailsService,
    private proceduresValidationService: ProceduresValidationService,
    private recipentsService: RecipientsService,
    private filesService: FilesService
  ) {
    const config = environment;
    this.baseUrlDocumentEditor = config.baseUrlDocumentEditor + 'DocumentEditor/';
    this.enableSpellCheck = config.enableSpellCheck;
    this.showDocExportBtn = config.showDocExportBtn;
    if (RELocalization) {
      loadMessages({ fr: RELocalization });
      locale('fr');
    }
  }

  ngOnInit(): void {
    this.translationPlaceholderPTree = this.translater.translate('pleaseSelectAService');

    this.generateRdGuid();
    this.contactLangue = sessionStorage.getItem('langue');
    this.exportBtnItems = [
      { label: '.docx/.doc', icon: 'bi--medium_icon bi bi-filetype-doc', click: () => this.exportDocx() },
      { label: '.rtf', icon: 'iconRTFFileSCSS', click: () => this.export('.rtf', '.rtf') },
      { label: '.pdf', icon: 'bi--medium_icon bi bi-filetype-pdf', click: () => this.export('.pdf', '.pdf') },
      { label: '.mail', icon: '', click: () => this.export('.mail', '.html') },
      { label: '.printshop', icon: 'bi--medium_icon bi bi-filetype-pdf', click: () => this.export('.printshop', '.pdf') },
      { label: '.odt', icon: 'bi--medium_icon bi bi-filetype-pdf', click: () => this.export('.odt', '.odt') },
      { label: '.html', icon: 'bi--medium_icon bi bi-filetype-pdf', click: () => this.export('.html', '.html') },
      { label: '.printshop-C5', icon: 'bi--medium_icon bi bi-filetype-pdf', click: () => this.export('.printshop-C5', '.pdf') },
    ];
  }

  getSignatureEmail(): void {
    this.servicesService.fetchSignature(this.courrier.serviceProprietaireId).subscribe({
      next: (res) => {
        const blob = new Blob([res.eMailSignatureRTF], { type: 'application/rtf' });
        if (blob) {
          this.documenteditorcontainer.rich.openDocument(blob, 'signature', DocumentFormatApi.Rtf, () => {
            this.spinner.hide();
          });
        }
      },
    });
  }

  ngAfterViewInit(): void {
    this.cd.markForCheck();
  }

  // Convert SFDT to WORD document then save file in local
  public export(selecteType: string, saveAsType: string): void {
    this.selectedType = selecteType;
    this.spinner.show();
    let blob = null;
    this.documenteditorcontainer.rich.exportToFile((file) => {
      blob = new Blob([file], { type: 'application/rtf' });
      saveAs(blob, this.fileName.split('.')[0] + saveAsType);
      this.spinner.hide();
    }, DocumentFormatApi.Rtf);
  }

  public exportDocx(): void {
    this.documenteditorcontainer.rich.exportToFile((file) => {
      const blob = new Blob([file], { type: 'application/rtf' });
      saveAs(blob, this.fileName.split('.')[0] + '.docx');
      this.spinner.hide();
    }, DocumentFormatApi.OpenXml);
  }

  // Open the print options window
  public onPrint(): void {
    this.documenteditorcontainer.rich.printDocument(PrintMode.Html);
  }

  // V2 $$$$$$$$$
  public transformDocument(fusionDestPrincipal?: boolean): void {
    this.spinner.show();
    const blob = new Blob([this.selectedTemplatelocation], { type: 'application/rtf' });
    this.blob = blob;
    this.filesService.transformDocument(this.mailId, blob, this.selectedTemplateName, fusionDestPrincipal, this.selectedDocumentTpl.id).subscribe({
      next: (blobResult) => {
        //si web alors if
        if (blobResult && this.selectedDocumentTpl?.editeurSourceType === 'Web') {
          setTimeout(() => {
            this.loadBlob(blobResult);
          }, 1000);
        }
        if (this.selectedDocumentTpl?.editeurSourceType === 'Externe') {
          this.transformedExternalDocument = blobResult;
          this.newblob = blobResult;
          this.spinner.hide();
        }

        // this.spinner.hide();
        // this.replaceImagesThenOpenDocument(response);
      },
      error: (error) => {
        console.error('Error : ', error);
        this.spinner.hide();
        this.toastr.error("Impossible d'afficher le modèle");
      },
    });
  }

  public loadBlob(blob: Blob): void {
    if (this.documenteditorcontainer) {
      this.documenteditorcontainer.rich.openDocument(blob, 'document', DocumentFormatApi.Rtf, () => {
        this.spinner.hide();
      });
    }
  }

  // $$$$$$ EMAIL $$$$$$$$$
  getMail(): Promise<boolean> {
    return new Promise((resolve) => {
      this.mailsService.fetchMailsById(this.mailId).subscribe({
        next: (response: MailDTO) => {
          this.courrier = new Mail(response);
          resolve(true);
        },
        error: (error) => {
          console.error('Error : ', error);
        },
      });
    });
  }

  getUserInfos(): void {
    this.usersService.fetchUserInfos().subscribe({
      next: (response: UserInfosDto) => {
        this.userInfos = response;

        this.getUserEmail();
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error : ', error);
      },
    });
  }

  getUserEmail(): void {
    this.contactsService.fetchContact(this.userInfos.contactId, 'iAdmin').subscribe({
      next: (response: ContactDto) => {
        this.connectedUser = response;
        const principalAd = this.connectedUser.listContactsAdresses.find((a) => a.type === 'PRINCIPALE');
        this.fromEmail = principalAd.adresse.mail;
        if (!this.fromEmail && (this.routeParams.mode === 'emailmodel' || this.routeParams.mode === 'emailnomodel')) {
          this.toastr.error("Attention, l'utilisateur connecté ne possède pas d'adresse mail. Cela peut provoquer des erreurs.");
        }
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }

  public getMailFiles(initial?: boolean): void {
    this.filesService.fetchMailFiles(this.mailId).subscribe({
      next: (response) => {
        const mailFiles = response.map((file) => {
          return new MailFile(file);
        });
        this.isDataLoaded = true;
        if (initial && initial === true) {
          mailFiles.map((f) => {
            f.type = 'mail';
            this.mailFiles.push(f);
          });
          this.selectedMailFiles = this.mailFiles;
          this.emailForm.patchValue({
            files: this.mailFiles,
          });
        } else {
          this.mailFiles = [];
          mailFiles.map((f) => {
            f.type = 'mail';
            this.mailFiles.push(f);
          });
          const diffNotInList = _.difference(this.selectedMailFiles, this.mailFiles);
          if (diffNotInList) {
            diffNotInList.map((file) => {
              this.selectedMailFiles.filter((f) => f.id !== file.id);
            });
            this.emailForm.patchValue({
              files: this.selectedMailFiles,
            });
            this.cd.markForCheck();
          }
        }

        this.cd.markForCheck();
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }

  getRecipients(): Promise<{ ids: number[]; idsiAdmin: number[] }> {
    return new Promise((resolve) => {
      this.recipentsService.getMailsDestinataires(this.mailId).subscribe({
        next: (response) => {
          this.recipientsList = [];
          this.destinatairesArray = response;
          // ajout des données des services possédant une adresse mail
          this.manageServicesRecipients().then(() => {
            let ids: Array<number> = [];
            let idsiAdmin: Array<number> = [];
            if (this.destinatairesArray.length > 0) {
              this.destinatairesArray.map((d) => {
                if (d.contactiAdminId !== null) {
                  idsiAdmin.push(d.contactiAdminId);
                } else if (d.contactId !== null) {
                  ids.push(d.contactId);
                } else if (d.libre !== null) {
                  const input = {
                    email: d.libre,
                    name: d.libre,
                    isFreeContact: true,
                  };
                  this.recipientsList.push(input);
                }
              });
            }
            ids = _.uniq(ids);
            idsiAdmin = _.uniq(idsiAdmin);
            resolve({ ids: ids, idsiAdmin: idsiAdmin });
          });
        },
        error: (error) => {
          console.error('Error : ', error);
        },
      });
    });
  }

  manageServicesRecipients(): Promise<boolean> {
    return new Promise((resolve) => {
      const listOfServicesRecipients = this.destinatairesArray.filter((recipient) => recipient.type === 'SERVICE');
      if (listOfServicesRecipients?.length) {
        //Si on a au moins un service on va devoir faire la récupération des services
        this.servicesService.fetchServices().subscribe({
          next: (services) => {
            this.servicesOfRecipients = services.map((service) => ({
              ...service,
              description: setServiceDescription(service),
            }));
            // Avec ces services on va récupérer les emails des services destinataires
            listOfServicesRecipients.forEach((serviceRecipient) => {
              const serviceFound = services.find((s) => s.id === serviceRecipient.contactId);
              if (serviceFound && serviceFound.email !== null && serviceFound.email !== '') {
                const input = {
                  email: serviceFound.email,
                  name: serviceFound.description,
                  isFreeContact: false,
                };
                this.recipientsList.push(input);
              }
            });
            resolve(true);
          },
        });
      } else {
        // Si on a pas de service on passe a la suite
        resolve(true);
      }
    });
  }

  getContacts(data: { ids: number[]; idsiAdmin: number[] }): Promise<boolean> {
    return new Promise((resolve) => {
      const notInEmailList = [];
      async.waterfall(
        [
          (callback) => {
            if (data.ids.length > 0) {
              this.contactsService.fetchSearchContacts({ ids: data.ids.join(',') }, 'iCourrier').subscribe({
                next: (response) => {
                  response.map((c) => {
                    const principalAdress = c.listContactsAdresses.find((a) => a.type === 'PRINCIPALE');
                    if (principalAdress?.adresse?.mail) {
                      const input = {
                        email: principalAdress.adresse.mail,
                        name: c.name,
                        isFreeContact: false,
                      };
                      this.recipientsList.push(input);
                    } else {
                      notInEmailList.push(c.name);
                    }
                  });
                  this.recipientsFromiCourrier = response;
                  callback();
                },
                error: () => {
                  this.toastr.error('Une erreur est survenue lors de la recherche des destinataires de iAdmin');
                  callback();
                },
              });
            } else {
              callback();
            }
          },
          (callback) => {
            if (data.idsiAdmin.length > 0) {
              this.contactsService.fetchSearchContacts({ ids: data.idsiAdmin.join(',') }, 'iAdmin').subscribe({
                next: (response) => {
                  response.map((c) => {
                    const principalAdress = c.listContactsAdresses.find((a) => a.type === 'PRINCIPALE');
                    if (principalAdress?.adresse?.mail) {
                      const input = {
                        email: principalAdress.adresse.mail,
                        name: c.name,
                        isFreeContact: false,
                      };
                      this.recipientsList.push(input);
                    } else {
                      notInEmailList.push(c.name);
                    }
                  });
                  this.recipientsFromiAdmin = response;
                  callback();
                },
                error: () => {
                  this.toastr.error('Une erreur est survenue lors de la recherche des destinataires de iAdmin');
                  callback();
                },
              });
            } else {
              callback();
            }
          },
        ],
        () => {
          this.notEmailList = notInEmailList.join(',');
          resolve(true);
        }
      );
    });
  }

  submitEmail(): void {
    this.spinner.show();
    const emailRecipients: EmailRecipient[] = [];
    const bccRecipients: EmailRecipient[] = [];
    const ccRecipients: EmailRecipient[] = [];
    const attachementIds: string[] = [];
    const staticFiles: File[] = [];
    if (this.f.recipients.value?.length) {
      this.f.recipients.value.forEach((r) => {
        const recipient = {
          email: r.email,
          isFreeContact: r.isFreeContact,
        };
        emailRecipients.push(recipient);
      });
      if (this.f.bcc.value?.length) {
        this.f.bcc.value.forEach((r) => {
          const recipient = {
            email: r,
          };
          bccRecipients.push(recipient);
        });
      }
      if (this.f.cc.value?.length) {
        this.f.cc.value.forEach((r) => {
          const recipient = {
            email: r,
          };
          ccRecipients.push(recipient);
        });
      }
      if (this.f.files.value?.length) {
        this.f.files.value.forEach((f) => {
          if (f.type === 'mail') {
            attachementIds.push(f.id);
          } else {
            staticFiles.push(f);
          }
        });
      }
      this.emailObject = new EmailInput({
        jsonData: {
          fromEmail: this.fromEmail ? this.fromEmail : '',
          to: emailRecipients,
          bcc: bccRecipients,
          cc: ccRecipients,
          subject: this.f.subject.value,
          attachementIds: attachementIds,
        },
        staticAttachments: staticFiles,
      });
    }
    this.documenteditorcontainer.rich.exportToFile((file) => {
      const blob = new Blob([file], { type: 'application/rtf' });
      const data = {
        editor: 'devexpress',
        type: '.html',
        data: blob,
      };
      this.documentsService.convertDocument(data).subscribe({
        next: (convertedFile) => {
          const reader = new FileReader();
          reader.addEventListener('loadend', () => {
            if (this.emailObject) {
              this.emailObject.jsonData.bodyHtml = reader.result.toString();
              this.sendMail(this.emailObject);
            } else {
              this.spinner.hide();
              this.toastr.error('Le corps du mail est requis');
            }
          });
          reader.readAsText(convertedFile);
        },
      });
    }, DocumentFormatApi.Rtf);
  }

  initForm(): void {
    if (!this.courrier) {
      this.mailsService.fetchMailsById(this.mailId).subscribe({
        next: (res: MailDTO) => {
          this.courrier = new Mail(res);
          this.emailForm.patchValue({
            subject: this.courrier && this.courrier.objet ? '#' + this.courrier.id + ' ' + this.courrier.objet : null,
          });
        },
      });
      this.spinner.hide();
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.emailForm.controls;
  }

  onAddRecipient(event): void {
    const input = {
      email: event.value,
      name: '',
      isFreeContact: true,
    };
    this.recipientsList.push(input);
    this.emailForm.patchValue({
      recipients: this.recipientsList,
    });
    this.emailForm.get('recipients').setErrors(null);
    for (let i = 0; i < this.recipientsList.length; i++) {
      const validMail = this.checkValidMail(this.recipientsList[i].email, false);

      if (!validMail) {
        this.emailForm.get('recipients').setErrors({ invalidEmail: true });
        break;
      }
    }
  }

  onRemoveRecipient(event): void {
    this.recipientsList = this.recipientsList.filter((r) => r.email !== event.value.email);
    this.emailForm.get('recipients').setErrors(null);
    if (this.recipientsList.length != 0) {
      for (let i = 0; i < this.recipientsList.length; i++) {
        const validMail = this.checkValidMail(this.recipientsList[i].email, false);

        if (!validMail) {
          this.emailForm.get('recipients').setErrors({ invalidEmail: true });
          break;
        }
      }
    }
  }

  /**
   * Check if the entered email is valid
   * @param {string} email - the email to be checked for validity
   * @param {Boolean} init - boolean flag to determine if form should be initialized
   */
  checkValidMail(email: string, init: boolean): boolean {
    // Check if the entered email is valid
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const validEmail: boolean = emailRegex.test(email);
    // Update form and add recipient if email is valid, otherwise set error
    init ? this.initForm() : null;
    return validEmail;
  }

  sendMail(emailInput: EmailInput): void {
    if (!emailInput.jsonData.fromEmail) {
      this.toastr.error(
        "Il n'existe pas d'adresse mail d'envoi. Le mail ne peut donc être créé. Veuillez ajouter une adresse mail principale au contact lié a votre utilisateur dans iAdmin."
      );
    } else {
      this.mailsService.sendEmailReply(this.courrier ? this.courrier.id : this.mailId, emailInput).subscribe({
        next: () => {
          this.spinner.hide();
          this.dataService.setCanLeaveEditor(true);
          this.toastr.success('Merci', 'Votre email a été envoyé');
          this.router.navigateByUrl('/private/ic/courriers/all/' + (this.courrier ? this.courrier.id : this.mailId));
        },
        error: (error) => {
          console.error('Error : ', error);
          this.spinner.hide();
          this.dataService.setCanLeaveEditor(false);
          this.toastr.error("Une erreur s'est produite, veuillez réessayer");
        },
      });
    }
  }

  saveMail(): void {
    const clientType = sessionStorage.getItem('clientType');
    let description = '';
    // on check si nePasProposerRenomer si c'est le cas on prend la description du template
    if (this.selectedDocumentTpl && this.selectedDocumentTpl.nePasproposerRenommer) {
      description = this.selectedDocumentTpl.description ? this.selectedDocumentTpl.description : 'untitled_document';
      if (description.length > 200) {
        description = description.substring(0, 199);
      }
      this.spinner.show();
      let blob = null;
      this.documenteditorcontainer.rich.exportToFile((file) => {
        blob = new Blob([file], { type: 'application/rtf' });
        if (clientType !== 'JVS') {
          this.addDocument(blob, description);
          this.spinner.hide();
        } else {
          this.addDocumentPastell(blob, { description: description });
          this.spinner.hide();
        }
      }, DocumentFormatApi.Rtf);
    } else {
      if (this.selectedDocumentTpl) {
        description = this.selectedDocumentTpl.description;
      } else {
        description = 'untitled_document';
      }

      const ref = this.dialog.open(DocumentSaveModalComponent, {
        dismissableMask: false,
        width: '60vw',
        header: 'Enregistrement du document',
        baseZIndex: 1000,
        data: {
          selectedDocumentTpl: this.selectedDocumentTpl ? this.selectedDocumentTpl : null,
        },
      });
      ref.onClose.subscribe({
        next: (value) => {
          if (value) {
            description = value;
            this.spinner.show();
            let blob = null;
            this.documenteditorcontainer.rich.exportToFile((file) => {
              blob = new Blob([file], { type: 'application/rtf' });
              if (clientType !== 'JVS') {
                this.addDocument(blob, description);
                this.spinner.hide();
              } else {
                this.addDocumentPastell(blob, { description: description });
                this.spinner.hide();
              }
            }, DocumentFormatApi.Rtf);
          }
        },
      });
    }
  }

  saveMailPastell(): void {
    let description = '';
    if (this.selectedDocumentTpl) {
      description = this.selectedDocumentTpl.description;
    } else {
      description = 'untitled_document';
    }

    const ref = this.dialog.open(DocumentSaveModalComponent, {
      dismissableMask: false,
      width: '60vw',
      header: 'Enregistrement du document',
      baseZIndex: 1000,
      data: {
        showDateLimite: false,
        selectedDocumentTpl: this.selectedDocumentTpl ? this.selectedDocumentTpl : null,
      },
    });

    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          description = value;
          // if ( (this.selectedDocumentTpl && this.selectedDocumentTpl.editeurSourceType === 'Web')|| !this.selectedDocumentTpl){
          let blob = null;
          this.documenteditorcontainer.rich.exportToFile((file) => {
            blob = new Blob([file], { type: 'application/rtf' });
            this.addDocumentPastell(blob, { description: description });
          }, DocumentFormatApi.Rtf);
        }
      },
    });
  }

  get procedureValidationQuestionPosees(): UntypedFormArray {
    return this.questionForm.get('ProcedureValidationQuestionPosees') as UntypedFormArray;
  }

  prepareToSave(externalMode = false): void {
    const clientType = sessionStorage.getItem('clientType');
    if (this.selectedDocumentTpl && this.selectedDocumentTpl['procedureValidationASuivre']) {
      this.confirmService.confirm({
        message: 'Lancer la validation/signature ?',
        accept: () => {
          this.lancerValidation = true;
          this.getQuestionsForFormValidation(clientType, externalMode);
        },
        reject: () => {
          this.lancerValidation = false;
          this.getQuestionsForFormValidation(clientType, externalMode);
          this.dataService.setCanLeaveEditor(true);
        },
      });
    } else {
      this.lancerValidation = null;
      this.saveMailByClientType(clientType, externalMode);
    }
  }

  getQuestionsForFormValidation(clientType, externalMode): void {
    const control = this.procedureValidationQuestionPosees;
    control.clear();
    control.updateValueAndValidity();
    this.proceduresValidationService.getQuestions(this.selectedDocumentTpl['procedureValidationASuivre']).subscribe({
      next: (res) => {
        if (res.length === 0) {
          this.showQuestion = false;
          this.saveMailByClientType(clientType, externalMode);
        } else {
          this.getRoles().then(() => {
            this.getServices().then(() => {
              res.map((item) => {
                control.push(
                  this.formBuilder.group({
                    id: item.id,
                    procedureValidationId: item.procedureValidationId,
                    roleId: item.roleId,
                    serviceId: [item.serviceId, Validators.required],
                    typeSignature: item.typeSignature,
                    questionPosee: item.questionPosee,
                  })
                );
              });
              this.showQuestion = true;
            });
          });
        }
      },
      error: () => {
        this.toastr.error("Une erreur s'est produite lors de la récupération des questions");
      },
    });
  }

  saveMailByClientType(clientType, externalMode): void {
    if (clientType !== 'JVS') {
      if (externalMode) {
        let description;
        if (this.selectedDocumentTpl?.nePasproposerRenommer) {
          //si on ne peut pas renommer, on récupère juste le nom initial
          description = this.selectedDocumentTpl.description ? this.selectedDocumentTpl.description : 'untitled_document';
          if (description.length > 200) {
            description = description.substring(0, 199);
          }
        } else {
          //si on peut rename alors on va call la modale de rename
          if (this.selectedDocumentTpl) {
            description = this.selectedDocumentTpl.description;
          } else {
            description = 'untitled_document';
          }

          const ref = this.dialog.open(DocumentSaveModalComponent, {
            dismissableMask: false,
            width: '60vw',
            header: 'Enregistrement du document',
            baseZIndex: 1000,
            data: {
              selectedDocumentTpl: this.selectedDocumentTpl ? this.selectedDocumentTpl : null,
            },
          });

          ref.onClose.subscribe({
            next: (value) => {
              if (value) {
                description = value;
              }
            },
          });
        }
        this.addDocument(this.newblob, description);
      } else {
        this.saveMail();
      }
    } else {
      if (externalMode) {
        let description;
        if (this.selectedDocumentTpl?.nePasproposerRenommer) {
          description = this.selectedDocumentTpl.description ? this.selectedDocumentTpl.description : 'untitled_document';
          if (description.length > 200) {
            description = description.substring(0, 199);
          }
        } else {
          if (this.selectedDocumentTpl) {
            description = this.selectedDocumentTpl.description;
          } else {
            description = 'untitled_document';
          }

          const ref = this.dialog.open(DocumentSaveModalComponent, {
            dismissableMask: false,
            width: '60vw',
            header: 'Enregistrement du document',
            baseZIndex: 1000,
            data: {
              showDateLimite: false,
              selectedDocumentTpl: this.selectedDocumentTpl ? this.selectedDocumentTpl : null,
            },
          });

          ref.onClose.subscribe({
            next: (value) => {
              if (value) {
                description = value;
              }
            },
          });
        }
        this.addDocumentPastell(this.newblob, {
          description: description ? description : 'document',
        });
      } else {
        this.saveMailPastell();
      }
    }
  }

  submit(): void {
    if (this.procedureValidationQuestionPosees.valid) {
      // || this.qstValidationAnnulee) {
      this.procedureValidationQuestionPosees.value.map((value) => {
        value.serviceId = value.serviceId?.id ? value.serviceId.id : null;
      });
      this.saveMail();
      this.showQuestion = false;
    } else {
      this.toastr.error('Veuillez remplir les champs obligatoires');
    }
  }

  getRoles(): Promise<boolean> {
    return new Promise((resolve) => {
      this.rolesService.getRolesMappedToPrimeNGDropdowns().subscribe({
        next: (res: DropdownRole[]) => {
          this.roles = [...res];
          resolve(true);
        },
      });
    });
  }
  getServices(): Promise<boolean> {
    return new Promise((resolve) => {
      this.servicesService.fetchMappedServicesToPrimeNGDropdowns().subscribe({
        next: (response) => {
          const datasForService = manageServicesSetAsTreeSelect(response, this.translater);
          this.serviceParent = datasForService.servicesForSingleCheck;
          this.servicesFusionned = manageServicesToBeMerged(response);
          resolve(true);
        },
      });
    });
  }

  addDocument(blob: Blob, fileName: string): void {
    this.spinner.show();
    let docInput: DocumentInput;
    this.dataService.setCanLeaveEditor(true);
    this.isFormSubmit = true;
    const mailIdAnswer = +sessionStorage.getItem('courrierIDAnswer');
    if (this.questionForm.value.ProcedureValidationQuestionPosees.length > 0) {
      this.questionForm.value.ProcedureValidationQuestionPosees.map((item) => {
        item.questionPosee ? delete item.questionPosee : null;
      });
    }
    if (this.selectedDocumentTpl && this.selectedDocumentTpl !== null) {
      docInput = new DocumentInput({
        pdfFileRequired: this.selectedDocumentTpl.nePasGenererDePdf ? false : true,
        file: blob,
        description: fileName,
        guid: this.guid,
        modeleId: this.selectedDocumentTpl.id,
        version: 1,
      });
    } else {
      docInput = new DocumentInput({
        pdfFileRequired: true,
        file: blob,
        description: fileName,
        guid: this.guid,
        version: 1,
      });
    }
    Object.keys(docInput).forEach((key) => docInput[key] == null && delete docInput[key]);
    if (this.lancerValidation !== null) {
      this.filesService
        .addDocument(
          this.mailId,
          docInput,
          this.lancerValidation,
          this.qstValidationAnnulee,
          this.questionForm.value.ProcedureValidationQuestionPosees
        )
        .subscribe({
          next: (response) => {
            if (this.publipostageOK) {
              sessionStorage.setItem('showModalPublipostageFileID', _.first(response.filter((x) => x.extension === 'rtf')).id);
            }
            this.spinner.hide();
            this.toastr.success('Merci', 'Votre document a été créé!');

            // Vu avec MPE ce 09/01/2022 => on vérifie ssi le modèle est imprimable + ssi c'est pas un publipostage => Si imprimable et pas publipostage alors on va
            // print ce qu'il y a à l'écran
            if (!this.publipostageOK && this.selectedDocumentTpl && !this.selectedDocumentTpl?.nePasProposerImprimer) {
              this.showPDF(blob);
            }
            if (mailIdAnswer) {
              this.router.navigateByUrl('/private/ic/courriers/sortants/' + this.mailId);
            } else {
              const category = localStorage.getItem('activeCategoryCourrier') ?? 'all';
              this.router.navigateByUrl('/private/ic/courriers/' + category + '/' + this.mailId);
            }
          },
          error: (error) => {
            console.error('Error : ', error);
            this.toastr.error("Une erreur est survenue lors de l'envoi du formulaire");
          },
        });
    } else {
      this.filesService.addDocument(this.mailId, docInput).subscribe({
        next: (response) => {
          if (this.publipostageOK) {
            sessionStorage.setItem('showModalPublipostageFileID', _.first(response.filter((x) => x.extension === 'rtf')).id);
          }
          this.toastr.success('Merci', 'Votre document a été créé!');

          // Vu avec MPE ce 09/01/2022 => on vérifie ssi le modèle est imprimable + ssi c'est pas un publipostage => Si imprimable et pas publipostage alors on va
          // print ce qu'il y a à l'écran
          if (!this.publipostageOK && this.selectedDocumentTpl && !this.selectedDocumentTpl?.nePasProposerImprimer) {
            this.showPDF(blob);
          }

          const category = localStorage.getItem('activeCategoryCourrier') ?? 'all';
          if (this.selectedDocumentTpl && this.selectedDocumentTpl.procedureValidationASuivre) {
            this.proceduresValidationService.getProcedureValidationById(this.selectedDocumentTpl.procedureValidationASuivre).subscribe({
              next: (res) => {
                const currentProcedure = _.first(res);
                if (currentProcedure.validationCsSignatures && currentProcedure.validationCsSignatures.length > 0) {
                  sessionStorage.setItem('fileIdForImportation', _.first(response.filter((x) => x.extension === 'rtf')).id);
                  if (mailIdAnswer) {
                    this.router.navigateByUrl('/private/ic/courriers/sortants/' + this.mailId);
                  } else {
                    this.router.navigateByUrl('/private/ic/courriers/' + category + '/' + this.mailId);
                  }
                } else {
                  if (mailIdAnswer) {
                    this.router.navigateByUrl('/private/ic/courriers/sortants/' + this.mailId);
                  } else {
                    this.router.navigateByUrl('/private/ic/courriers/' + category + '/' + this.mailId);
                  }
                }
              },
            });
          } else {
            if (mailIdAnswer) {
              this.router.navigateByUrl('/private/ic/courriers/sortants/' + this.mailId);
            } else {
              this.router.navigateByUrl('/private/ic/courriers/' + category + '/' + this.mailId);
            }
          }
        },
        error: (error) => {
          console.error('Error : ', error);
          this.toastr.error("Une erreur est survenue lors de l'envoi du formulaire");
        },
      });
    }
  }

  addDocumentPastell(blob: Blob, file: { description: string }): void {
    let docInput: DocumentInput;
    this.dataService.setCanLeaveEditor(true);
    if (this.questionForm.value.ProcedureValidationQuestionPosees.length > 0) {
      this.questionForm.value.ProcedureValidationQuestionPosees.map((item) => {
        delete item.questionPosee;
      });
    }
    this.isFormSubmit = true;
    const mailIdAnswer = +sessionStorage.getItem('courrierIDAnswer');
    if (this.selectedDocumentTpl && this.selectedDocumentTpl !== null) {
      docInput = new DocumentInput({
        file: blob,
        description: file.description,
        guid: this.guid,
        modeleId: this.selectedDocumentTpl.id,
        version: 1,
        attachmentIds: '',
      });
    } else {
      docInput = new DocumentInput({
        file: blob,
        description: file.description,
        guid: this.guid,
        version: 1,
        attachmentIds: '',
      });
    }
    Object.keys(docInput).forEach((key) => docInput[key] == null && delete docInput[key]);
    if (this.selectedDocumentTpl && this.selectedDocumentTpl.procedureValidationASuivre) {
      this.proceduresValidationService.getProcedureValidationById(this.selectedDocumentTpl.procedureValidationASuivre).subscribe({
        next: (res) => {
          const currentProcedure = _.first(res);
          if (currentProcedure.pastellCircuitId !== null) {
            const ref = this.dialog.open(AssignAttachmentsComponent, {
              showHeader: false,
              styleClass: 'super-compos-modal-content ',
              dismissableMask: false,
              width: '60vw',
              data: {
                courrierID: mailIdAnswer ? mailIdAnswer : this.mailId,
                attachementMode: true,
              },
            });
            ref.onClose.subscribe({
              next: (value) => {
                if (value) {
                  this.spinner.show();
                  docInput.attachmentIds = JSON.stringify(value.attachmentsIds);
                  this.filesService
                    .addDocumentPastell(
                      this.mailId,
                      docInput,
                      this.lancerValidation ? true : false,
                      this.qstValidationAnnulee ? true : false,
                      this.questionForm.value.ProcedureValidationQuestionPosees
                    )
                    .subscribe({
                      next: (response) => {
                        if (this.publipostageOK) {
                          sessionStorage.setItem('showModalPublipostageFileID', _.first(response.filter((x) => x.extension === 'rtf')).id);
                        }
                        this.spinner.hide();
                        this.toastr.success('Merci', 'Votre document a été créé!');

                        // Vu avec MPE ce 09/01/2022 => on vérifie ssi le modèle est imprimable + ssi c'est pas un publipostage => Si imprimable et pas publipostage alors on va
                        // print ce qu'il y a à l'écran
                        if (!this.publipostageOK && this.selectedDocumentTpl && !this.selectedDocumentTpl?.nePasProposerImprimer) {
                          this.showPDF(blob);
                        }
                        if (mailIdAnswer) {
                          this.router.navigateByUrl('/private/ic/courriers/sortants/' + this.mailId);
                        } else {
                          const category = localStorage.getItem('activeCategoryCourrier') ?? 'all';
                          this.router.navigateByUrl('/private/ic/courriers/' + category + '/' + this.mailId);
                        }
                        sessionStorage.removeItem('courrierIDAnswer');
                      },
                      error: (error) => {
                        console.error('Error : ', error);
                        this.toastr.error("Une erreur est survenue lors de l'envoi du formulaire");
                      },
                    });
                }
              },
            });
          } else {
            docInput.attachmentIds = '';
            this.filesService
              .addDocumentPastell(
                this.mailId,
                docInput,
                this.lancerValidation ? true : false,
                this.qstValidationAnnulee ? true : false,
                this.questionForm.value.ProcedureValidationQuestionPosees
              )
              .subscribe({
                next: (response) => {
                  if (this.publipostageOK) {
                    sessionStorage.setItem('showModalPublipostageFileID', _.first(response.filter((x) => x.extension === 'rtf')).id);
                  }
                  this.spinner.hide();
                  this.toastr.success('Merci', 'Votre document a été créé!');

                  // Vu avec MPE ce 09/01/2022 => on vérifie ssi le modèle est imprimable + ssi c'est pas un publipostage => Si imprimable et pas publipostage alors on va
                  // print ce qu'il y a à l'écran
                  if (!this.publipostageOK && this.selectedDocumentTpl && !this.selectedDocumentTpl?.nePasProposerImprimer) {
                    this.showPDF(blob);
                  }
                  if (mailIdAnswer) {
                    this.router.navigateByUrl('/private/ic/courriers/sortants/' + this.mailId);
                  } else {
                    const category = localStorage.getItem('activeCategoryCourrier') ?? 'all';
                    this.router.navigateByUrl('/private/ic/courriers/' + category + '/' + this.mailId);
                  }
                  sessionStorage.removeItem('courrierIDAnswer');
                },
                error: (error) => {
                  console.error('Error : ', error);
                  this.toastr.error("Une erreur est survenue lors de l'envoi du formulaire");
                },
              });
          }
        },
      });
    } else {
      this.filesService
        .addDocumentPastell(
          this.mailId,
          docInput,
          this.lancerValidation ? true : false,
          this.qstValidationAnnulee ? true : false,
          this.questionForm.value.ProcedureValidationQuestionPosees
        )
        .subscribe({
          next: (response) => {
            this.spinner.hide();
            this.toastr.success('Merci', 'Votre document a été créé!');
            if (this.publipostageOK) {
              sessionStorage.setItem('showModalPublipostageFileID', _.first(response.filter((x) => x.extension === 'rtf')).id);
            }

            // Vu avec MPE ce 09/01/2022 => on vérifie ssi le modèle est imprimable + ssi c'est pas un publipostage => Si imprimable et pas publipostage alors on va
            // print ce qu'il y a à l'écran
            if (!this.publipostageOK && this.selectedDocumentTpl && !this.selectedDocumentTpl?.nePasProposerImprimer) {
              this.showPDF(blob);
            }
            if (mailIdAnswer) {
              this.router.navigateByUrl('/private/ic/courriers/sortants/' + this.mailId);
              sessionStorage.removeItem('courrierIDAnswer');
              localStorage.removeItem('isAnswer');
            } else {
              const category = localStorage.getItem('activeCategoryCourrier') ?? 'all';
              this.router.navigateByUrl('/private/ic/courriers/' + category + '/' + this.mailId);
            }
          },
          error: (error) => {
            console.error('Error : ', error);
            this.toastr.error("Une erreur est survenue lors de l'envoi du formulaire");
          },
        });
    }
  }

  public generateRdGuid(): void {
    this.guid = uuidv4();
  }

  cancelQuestion(): void {
    // this.confirmService.confirm({
    //   message:
    //     'Attention, si vous annulez les questions, la procédure continuera mais annulera les questions. Souhaitez-vous annuler les questions?',
    //   accept: () => {
    //     this.qstValidationAnnulee = true;
    this.showQuestion = false;
    //     this.submit();
    //   },
    // });
  }

  cancel(): void {
    this.confirmService.confirm({
      message: 'Attention, si vous continuez, vos données ne seront pas sauvegardées. Êtes vous sûr de vouloir quitter ?',
      accept: () => {
        this.currentFile.emit('reload');
      },
    });
  }

  openFilesModal(): void {
    const ref = this.dialog.open(EmailFileSelectModalComponent, {
      dismissableMask: false,
      width: '60vw',
      header: this.translater.translate('chooseJointFiles'),
      baseZIndex: 1000,
      data: {
        mailFiles: this.mailFiles,
        selectedMailFiles: this.selectedMailFiles,
      },
    });

    ref.onClose.subscribe({
      next: (value: { form: MailFile[]; staticFiles: File[] }) => {
        this.selectedMailFiles = [];

        this.emailForm.patchValue({
          files: null,
          staticAttachments: null,
        });

        if (value?.form.length > 0) {
          value.form = value.form.map((v) => {
            v.type = 'mail';
            this.selectedMailFiles.push(v);
            return v;
          });
        }
        if (value?.staticFiles.length > 0) {
          value.staticFiles.forEach((v) => {
            this.selectedMailFiles.push(v);
          });
        }
        this.emailForm.patchValue({
          files: this.selectedMailFiles,
        });
        this.cd.markForCheck();
      },
    });
  }

  getParagraphes(): void {
    this.spinner.show();
    this.LIST_IDS = [];
    this.documentsService.fetchLibraryParagraphs().subscribe({
      next: (res: LibraryParagraphDto[]) => {
        this.paragraphes = _.groupBy(res, 'bibliothequeName');
        const keys = Object.keys(this.paragraphes);
        keys.forEach((key, index) => {
          this.LIST_IDS.push('cdk-drop-list-' + index);
        });
        this.spinner.hide();
      },
    });
  }

  getFusions(): void {
    this.spinner.show();
    this.documentsService.getFusionsField().subscribe({
      next: (res) => {
        this.fusions = res;
        this.spinner.hide();
      },
    });
  }

  public insert(variable): void {
    const cursorPosition = this.documenteditorcontainer.rich.selection.start;
    this.documenteditorcontainer.rich.document.insertText(cursorPosition, variable);
  }

  public dropped(event: CdkDragDrop<string[]>): void {
    const text = event.item && event.item.data;
    const cursorPosition = this.documenteditorcontainer.rich.selection.start;
    this.documenteditorcontainer.rich.document.insertText(cursorPosition, text);
  }

  insertParagraphes(text): void {
    clearTimeout(this.timer);
    if (text.texteRtf) {
      const cursorPosition = this.documenteditorcontainer.rich.selection.start;
      this.documenteditorcontainer.rich.selection.activeSubDocument.insertRtf(cursorPosition, text.texteRtf);
    }
  }

  showPDF(blobFromSave: Blob = null): Promise<boolean> {
    return new Promise((resolve) => {
      const data = {
        editor: 'devexpress',
        type: '.pdf',
        data: blobFromSave === null ? this.transformedExternalDocument : blobFromSave,
      };
      this.spinner.show();
      this.showPDFModal = true;
      this.documentsService.convertDocument(data).subscribe({
        next: (res: Blob) => {
          this.pdfConverted = URL.createObjectURL(res);
          sessionStorage.setItem('pdf', this.pdfConverted);
          if (blobFromSave !== null) {
            sessionStorage.setItem('iCourrierPdfAutoPrint', 'true');
          } else sessionStorage.setItem('iCourrierPdfAutoPrint', 'false');

          const baseURl = '/private/ic/file-viewer/';
          window.open(baseURl, '_blank');
          this.spinner.hide();
          resolve(true);
        },
      });
    });
  }

  downloadFile(): void {
    const url = URL.createObjectURL(this.transformedExternalDocument);
    saveAs(url, this.selectedTemplateName ? this.selectedTemplateName : '');
  }

  onUpload(event): void {
    let array = [];
    if (event.files && event.files.length > 0) {
      array = event.files;
      const blob = new Blob([array[0]], { type: 'application/rtf' });
      this.newblob = blob;
      this.prepareToSave(true);
    }
  }

  pageRendered($event): void {
    const $canvas = $event.source.canvas;
    this.arrayCanvas.push({
      page: $event.pageNumber,
      canvas: $canvas,
    });
  }

  copy(event, text): void {
    if (event.detail === 1) {
      this.timer = setTimeout(() => {
        navigator.clipboard.writeText(text.texte).then(
          function () {
            console.info('Async: Copying to clipboard was successful!');
          },
          function (err) {
            console.error('Async: Could not copy text: ', err);
          }
        );
        this.toastr.success('La valeur ' + text.description + ' est copié dans votre presse-papier');
      }, 500);
    }
    // navigator.clipboard.writeText(text.texte).then(function() {
    // }, function(err) {
    //   console.error('Async: Could not copy text: ', err);
    // });
    // this.toastr.success('La valeur ' + text.description + ' est copié dans votre presse-papier')
  }

  showQRModal(): void {
    const ref = this.dialog.open(QrCodeModalComponent, {
      showHeader: false,
      styleClass: 'super-compos-modal-content ',
      dismissableMask: false,
      width: '60vw',
    });
    ref.onClose.subscribe({
      next: (res: null | CreateQRCodeParams) => {
        res.texte = '%Sign Signature' + res.texte + '%';
        this.docService.postCreateQRCode(res).subscribe({
          next: (blob) => {
            this.blobToBase64(blob).then((base64: string) => {
              if (base64) {
                const cursorPosition = this.documenteditorcontainer.rich.selection.start;
                this.documenteditorcontainer.rich.document.insertPicture(cursorPosition, base64, {
                  width: res.width ? res.width * 10 : 1000,
                  height: res.height ? res.height * 10 : 1000,
                });
                this.toastr.success('Le code QR a bien été géneré!');
                this.displayQR = false;
              }
            });
          },
        });
      },
    });
  }

  blobToBase64(blob): Promise<string | ArrayBuffer> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }
}
